export function projectWorkSuggestions(project) {
  const name = project.name || 'this project';
  const scope = `Work in the selected project folder (${name}). Inspect its existing files first and base your answer only on this project.`;
  return [
    { id: 'project-overview', icon: 'folder', label: 'Explore this project',
      description: 'Understand the files and how they fit together',
      prompt: `${scope} Give me a concise overview of what it contains, how it is organized, and where to start.` },
    { id: 'project-review', icon: 'magnifying-glass', label: 'Review recent changes',
      description: 'Check the latest work in this folder',
      prompt: `${scope} Review recent changes for concrete problems or inconsistencies. Use Git history if available, and explain any limits on what you can verify.` },
    { id: 'project-improve', icon: 'wand-magic-sparkles', label: 'Find the next improvement',
      description: 'Identify a useful next step for this project',
      prompt: `${scope} Identify the most useful next improvement supported by the files and explain a focused plan to make it.` },
    { id: 'project-docs', icon: 'file-lines', label: 'Update project docs',
      description: 'Bring the documentation up to date',
      prompt: `${scope} Update or create a concise project overview using the existing documentation style. Describe what is actually present without inventing features.` },
  ];
}
